module.exports = __webpack_public_path__ + "static/media/goingForGold.d2f6ea76.jpg";